import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card } from "../../components/ui/card";
import { adminApi, tokens } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await adminApi.post("/admin/login", { email, password });
      tokens.setAdmin(data.access_token);
      toast.success("Bienvenido al panel");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Credenciales inválidas");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cm-ink relative flex items-center justify-center p-4" data-testid="admin-login-page">
      <img
        src="https://static.prod-images.emergentagent.com/jobs/bd543d09-1af2-4218-af84-8180b654732b/images/b64ec2527c2d53569dde05cc814c86b3512f4e52695389a90fee34dbe580ec98.png"
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <Card className="relative w-full max-w-md bg-white border-0 shadow-2xl p-8 sm:p-10">
        <Link to="/" className="inline-flex items-center gap-2.5 mb-8">
          <img src="/cm-logo.jpeg" alt="CM" className="h-11 w-11 rounded-full object-cover ring-2 ring-cm-red/30" />
          <div>
            <div className="font-serif text-sm">CM Calidad y Servicio</div>
            <div className="text-[10px] uppercase tracking-widest text-cm-ink-soft">Panel administrativo</div>
          </div>
        </Link>

        <div className="mb-6">
          <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-cm-ink-soft font-medium">
            <Lock className="h-3 w-3" /> Acceso restringido
          </div>
          <h1 className="font-serif text-3xl mt-2 tracking-tight">Ingreso del equipo</h1>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="admin-email">Correo</Label>
            <Input
              id="admin-email" type="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-11 border-cm-border focus-visible:ring-cm-red focus-visible:ring-offset-0"
              data-testid="admin-email-input" autoFocus
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="admin-password">Contraseña</Label>
            <Input
              id="admin-password" type="password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-11 border-cm-border focus-visible:ring-cm-red focus-visible:ring-offset-0"
              data-testid="admin-password-input"
            />
          </div>

          {error && (
            <div className="bg-cm-red/10 border border-cm-red/30 text-cm-red text-sm rounded-md px-3 py-2" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <Button type="submit" disabled={loading} className="w-full h-11 btn-cm-primary" data-testid="admin-login-btn">
            {loading ? "Verificando..." : <>Entrar al panel <ArrowRight className="ml-2 h-4 w-4" /></>}
          </Button>
        </form>

        <p className="mt-6 text-center text-xs text-cm-ink-soft">
          <Link to="/" className="hover:text-cm-red">← Volver al portal de clientes</Link>
        </p>
      </Card>
    </div>
  );
}
